export var Alphabet;
(function (Alphabet) {
    Alphabet["A"] = "A";
    Alphabet["B"] = "B";
    Alphabet["C"] = "C";
    Alphabet["D"] = "D";
    Alphabet["E"] = "E";
    Alphabet["F"] = "F";
    Alphabet["G"] = "G";
    Alphabet["H"] = "H";
    Alphabet["I"] = "I";
    Alphabet["J"] = "J";
    Alphabet["K"] = "K";
    Alphabet["L"] = "L";
    Alphabet["M"] = "M";
    Alphabet["N"] = "N";
    Alphabet["O"] = "O";
    Alphabet["P"] = "P";
    Alphabet["Q"] = "Q";
    Alphabet["R"] = "R";
    Alphabet["S"] = "S";
    Alphabet["T"] = "T";
    Alphabet["U"] = "U";
    Alphabet["V"] = "V";
    Alphabet["W"] = "W";
    Alphabet["X"] = "X";
    Alphabet["Y"] = "Y";
    Alphabet["Z"] = "Z";
})(Alphabet || (Alphabet = {}));
//# sourceMappingURL=CsAZList.js.map